import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.scss']
})
export class StatsCardComponent {
  @Input() count: number
  @Input() label: string
}
